var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modifyBookingPropData
    ? _c("section", { staticClass: "lookup-reservation component" }, [
        _vm.check.isLgAndDown
          ? _c("div", { staticClass: "lookup-reservation-image" }, [
              _c(
                "picture",
                {
                  directives: [
                    {
                      name: "lazyload",
                      rawName: "v-lazyload",
                      value: {
                        src: "" + _vm.BookingFormImage,
                        set: [
                          { width: "1024", height: 576, breakpoint: "xs" },
                          { width: "1280", height: 720, breakpoint: "md" },
                          { width: "1600", height: 900, breakpoint: "lg" },
                        ],
                        fit: "crop",
                        align: "center",
                      },
                      expression:
                        "{\n        src: `${BookingFormImage}`,\n        set: [\n          { width: '1024',height: 576, breakpoint: 'xs' },\n          { width: '1280', height: 720, breakpoint: 'md' },\n          { width: '1600', height: 900, breakpoint: 'lg' },\n        ],\n        fit: 'crop',\n        align: 'center',\n      }",
                    },
                  ],
                  staticClass: "image-wrapper background",
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                      alt: _vm.modifyBookingPropData.BookingFormImageAlt,
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "lookup-reservation-image__heading" }, [
                _vm._v("\n      " + _vm._s(_vm.BookingFormTitle) + "\n    "),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showLoading
          ? _c("div")
          : _c("div", { staticClass: "lookup-reservation-content" }, [
              _vm.check.isLgAndUp
                ? _c(
                    "h1",
                    { staticClass: "lookup-reservation-content__heading" },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.BookingFormTitle) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "lookup-reservation-content__sub-heading",
                domProps: { textContent: _vm._s(_vm.BookingFormSubTitle) },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-wrapper" }, [
                _c(
                  "form",
                  {
                    staticClass: "form modify-reservation-lookup-form",
                    attrs: { id: "modify-reservation-lookup-form" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("fieldset", [
                      _c("legend", { staticClass: "sr-only" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.BookingFormTitle) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-grid-1-col gutter-lg" }, [
                        _c("div", { staticClass: "input lookup-number" }, [
                          _c("div", { staticClass: "input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.LookUpNumber,
                                  expression: "LookUpNumber",
                                },
                              ],
                              staticClass: "req",
                              class: { valid: _vm.isValidLookUpNumber },
                              attrs: {
                                id: "lookupnumber",
                                type: "text",
                                name: "lookupnumber",
                                maxlength: "15",
                                value: "",
                                "data-val": "true",
                                "data-rule-maxlength": "50",
                                "data-msg-maxlength": _vm.getValidationForField(
                                  "maxChars",
                                  "50"
                                ),
                                "data-val-required": _vm.getValidationForField(
                                  "required",
                                  "confirmationOrItinerary"
                                ),
                                "data-val-no-special-chars": _vm.tc(
                                  "validations.noSpecialChars"
                                ),
                                "data-field-type": "SingleLineText",
                              },
                              domProps: { value: _vm.LookUpNumber },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.LookUpNumber = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "req floating",
                                attrs: { for: "lookupnumber" },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.tc(
                                        "formFields.confirmationOrItinerary"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "field-validation-valid",
                              attrs: {
                                "data-valmsg-for": "lookupnumber",
                                "data-valmsg-replace": "true",
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input email" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.EmailValue,
                                expression: "EmailValue",
                              },
                            ],
                            ref: "EmailRef",
                            staticClass: "req",
                            class: { valid: _vm.isEmailValid },
                            attrs: {
                              id: "email",
                              type: "text",
                              name: "email",
                              value: "",
                              "data-val": "true",
                              "data-val-external": "email",
                              "data-rule-minlength": "6",
                              "data-rule-maxlength": "255",
                              "data-msg-minlength": _vm.getValidationForField(
                                "minChars",
                                "6"
                              ),
                              "data-msg-maxlength": _vm.getValidationForField(
                                "maxChars",
                                "255"
                              ),
                              "data-external-msg":
                                _vm.getValidationForField("externalEmail"),
                              "data-val-required": _vm.getValidationForField(
                                "required",
                                "email"
                              ),
                              "data-val-regex":
                                _vm.getValidationForField("email"),
                              "data-val-regex-pattern":
                                "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$",
                            },
                            domProps: { value: _vm.EmailValue },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.EmailValue = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "req floating",
                              attrs: { for: "email" },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.tc("formFields.email")) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "field-validation-valid",
                            attrs: {
                              "data-valmsg-for": "email",
                              "data-valmsg-replace": "true",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.ReCaptchaEnabled
                      ? [
                          _c("grecaptcha", {
                            ref: "grecaptchaLogin",
                            attrs: {
                              sitekey: _vm.ReCaptchaSiteKey,
                              "element-id": "g-recaptcha",
                            },
                            on: {
                              "grecaptcha-callback": _vm.grecaptchaCallback,
                              "grecaptcha-ready": _vm.grecaptchaReadyCallback,
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.grecaptchaToken,
                                expression: "grecaptchaToken",
                              },
                            ],
                            attrs: { type: "hidden", name: "grecaptchaToken" },
                            domProps: { value: _vm.grecaptchaToken },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.grecaptchaToken = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "reCaptchaEnabled" },
                            domProps: { value: _vm.ReCaptchaEnabled },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-submit" }, [
                      _vm.ReCaptchaEnabled
                        ? _c(
                            "button",
                            {
                              staticClass: "button lookup-cta",
                              class: { loading: _vm.readReservationLoading },
                              attrs: {
                                disabled:
                                  !_vm.disableSubmit || !_vm.grecaptchaReady,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.grecaptchaExecute($event)
                                },
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.grecaptchaExecute($event)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.grecaptchaExecute($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.BookingFormButtonLabel)),
                              ]),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "button lookup-cta",
                              class: { loading: _vm.readReservationLoading },
                              attrs: { disabled: !_vm.disableSubmit },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submit($event)
                                },
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.submit($event)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.submit($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.BookingFormButtonLabel)),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sr-only", attrs: { role: "status" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.readReservationLoading
                                  ? _vm.tc("accessibility.loadingButtonStatus")
                                  : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "error-msg",
                      attrs: { role: "status" },
                      domProps: {
                        innerHTML: _vm._s(_vm.getReadReservationError),
                      },
                    }),
                    _vm._v(" "),
                    _c("loading-dots"),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "lookup-reservation-footertext",
                  domProps: { innerHTML: _vm._s(_vm.BookingFormFooterText) },
                }),
              ]),
            ]),
        _vm._v(" "),
        _vm.check.isLgAndUp
          ? _c("div", { staticClass: "lookup-reservation-image" }, [
              _c(
                "picture",
                {
                  directives: [
                    {
                      name: "lazyload",
                      rawName: "v-lazyload",
                      value: {
                        src: "" + _vm.BookingFormImage,
                        set: [
                          { width: "1024", height: 576, breakpoint: "xs" },
                          { width: "1280", height: 720, breakpoint: "md" },
                          { width: "1600", height: 900, breakpoint: "lg" },
                        ],
                        fit: "crop",
                        align: "center",
                      },
                      expression:
                        "{\n        src: `${BookingFormImage}`,\n        set: [\n          { width: '1024',height: 576, breakpoint: 'xs' },\n          { width: '1280', height: 720, breakpoint: 'md' },\n          { width: '1600', height: 900, breakpoint: 'lg' },\n        ],\n        fit: 'crop',\n        align: 'center',\n      }",
                    },
                  ],
                  staticClass: "image-wrapper background",
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                      alt: _vm.modifyBookingPropData.BookingFormImageAlt,
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }